import { IUser } from 'interfaces/users';

/** Normalized shape used only for dirty comparison (matches submit normalization). */
export interface ProfileSnapshot {
  email: string;
  name: string;
  personal_info_attributes: {
    full_name: string;
    document_info: string;
    phone_number: string;
  };
}

export function profileSnapshotFromRecord(record: IUser): ProfileSnapshot {
  return {
    email: String(record.email ?? '').trim(),
    name: String(record.name ?? '').trim(),
    personal_info_attributes: {
      full_name: String(record.personal_info?.full_name ?? '').trim(),
      document_info: String(record.personal_info?.document_info ?? '').replace(
        /\D/g,
        ''
      ),
      phone_number: String(record.personal_info?.phone_number ?? '').replace(
        /\D/g,
        ''
      )
    }
  };
}

export function profileSnapshotFromFormValues(
  values: Record<string, unknown>,
  record: IUser
): ProfileSnapshot {
  const pi = (values.personal_info_attributes ?? {}) as Record<string, unknown>;

  return {
    email: String(values.email ?? '').trim(),
    name: String(values.name ?? '').trim(),
    personal_info_attributes: {
      full_name: String(pi.full_name ?? '').trim(),
      document_info: String(pi.document_info ?? '').replace(/\D/g, ''),
      phone_number: String(pi.phone_number ?? '').replace(/\D/g, '')
    }
  };
}

function profileSnapshotsEqual(
  a: ProfileSnapshot,
  b: ProfileSnapshot
): boolean {
  return (
    a.email === b.email &&
    a.name === b.name &&
    a.personal_info_attributes.full_name ===
      b.personal_info_attributes.full_name &&
    a.personal_info_attributes.document_info ===
      b.personal_info_attributes.document_info &&
    a.personal_info_attributes.phone_number ===
      b.personal_info_attributes.phone_number
  );
}

export function isProfilePristine(
  formValues: Record<string, unknown>,
  record: IUser
): boolean {
  return profileSnapshotsEqual(
    profileSnapshotFromFormValues(formValues, record),
    profileSnapshotFromRecord(record)
  );
}
